import React, { useState, useEffect, useRef } from 'react';
import { LabelField } from './Third.style';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import ConfBar from '../ConfBar/ConfBar';
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelExport } from '../../services/excelExport.service';


/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Social_benefits
Description : Pagina de costos contables para el CRUD de las prestaciones sociales del aplicativo remunerlite.
Date Autor Modification
================================================================================
15/10/2021 Cristian Andres Pizo Mina - Pagina de Prestaciones sociales
================================================================================ */

export default function Social_benefits() {
  const toast = useRef(null);
  const [updateId, setUpdateId] = useState("");
  const setOptions_edit = []
  const [companyNit, setCompanyNit] = useState("");
  const [digitoVerificacion, setDigitoVerificacion] = useState("");
  const [nameCompany, setNameCompany] = useState("");
  const [listaTypeDocument, SetListaTypeDocument] = useState([]);
  const [typeDocument, setTypeDocument] = useState("");
  const [updateTypeDocument, setUpdateTypeDocument] = useState("");
  const [updateCompanyNit, setUpdateCompanyNit] = useState("");
  const [updateDigitoVerificacion, setUpdateDigitoVerificacion] = useState("");
  const [updateNameCompany, setUpdateNameCompany] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [rowData, setRowData] = useState([]);
  const [rowDataExport, setRowDataExport] = useState([]);
  const headers = { authorization: localStorage.getItem('token') }
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "27rem" }
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadPage, setLoadPage] = useState(false)
  const [loading2, setLoading2] = useState(false);

  useEffect(() => {
    const getLists = async () => {
      await apis.getThirdList(headers).then(res => {
        let thirdDocument = res.data["THIRDS"]["TIPO DE IDENTIDAD"]
        let contenidoTypeDocument = []
        thirdDocument.forEach(element => {
          contenidoTypeDocument.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        SetListaTypeDocument(contenidoTypeDocument);

      }).catch(err => {
        //  toast.current.show({severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true});
      })
      setTabla();
    }
    getLists()
  }, []);





  async function setTabla() {
    await apis.getThird(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["THIRDS"].length > 0) {
        let data = res.data["THIRDS"]
        let contenidoTabla = []
        let contenidoTablaExport = []
        data.forEach(element => {
          let document_type = element["DOCUMENT_TYPE"].split("|")
          contenidoTabla.push({ THIRD_ID: element.THIRD_ID, DOCUMENT_TYPE_ID: document_type[0], DOCUMENT_TYPE: document_type[1], DV: element.DV, NAME: element.NAME, NIT: element.NIT })
          let _element = {
            'Tipo de Documento': document_type[1],
            'Nit': element.NIT,
            'Dígito': element.DV,
            'Nombre': element.NAME
          }
          contenidoTablaExport.push(_element)
        })
        setRowDataExport(contenidoTablaExport)
        setRowData(contenidoTabla)
        setLoadPage(true)
      } else {
        setRowDataExport([])
        setRowData([])
        setLoadPage(true)
      }
    }).catch(err => {
      setLoadPage(true)
      // toast.current.show({severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true});
    })
  }

  const showModal = () => {
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const showModal_ = () => {
    setIsOpen_(true);
  };

  const hideModal_ = () => {
    setIsOpen_(false)
  };


  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  function inizilaizarData(rowData) {
    setOptions_edit.push({ "value": '' + rowData.DOCUMENT_TYPE_ID + '', "label": '' + rowData.DOCUMENT_TYPE + '' });
    setUpdateId(rowData.THIRD_ID)
    setUpdateTypeDocument(setOptions_edit[0])
    setUpdateCompanyNit(rowData.NIT)
    setUpdateDigitoVerificacion(rowData.DV)
    setUpdateNameCompany(rowData.NAME)
    showModal_();
  }

  async function completarRegistro() {

    setLoadingCreate(true)
    const _typeDocument = typeDocument.value;
    const _companyNit = companyNit;
    const _nameCompany = nameCompany;
    const _client = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');
    const _digitoVerificacion = digitoVerificacion

    const third = {
      CLIENT: _client,
      ENTITY: _entity,
      NIT: _companyNit,
      DOCUMENT_TYPE: _typeDocument,
      DV: _digitoVerificacion,
      NAME: _nameCompany
    }

    await apis.postThird(third, headers).then(res => {
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Tercero creado con éxito', life: 4000 });
      setLoadingCreate(false)
      hideModal();
      setTabla();
      limpiar();
    }).catch(err => {
      setLoadingCreate(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })


  }


  async function limpiar() {
    setTypeDocument("");
    setCompanyNit("");
    setDigitoVerificacion("");
    setNameCompany("");
  }

  async function actualizar() {
    setLoadingUpdate(true)
    const _typeDocument = updateTypeDocument.value;
    const _companyNit = updateCompanyNit;
    const _nameCompany = updateNameCompany;
    const _client = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');
    const _digitoVerificacion = updateDigitoVerificacion
    const _third_id = updateId;

    const third = {
      CLIENT: _client,
      ENTITY: _entity,
      NIT: _companyNit,
      DOCUMENT_TYPE: _typeDocument,
      DV: _digitoVerificacion,
      NAME: _nameCompany,
      THIRD_ID: _third_id
    }
    await apis.putThird(third, headers).then(res => {
      setLoadingUpdate(false)
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente', life: 4000 });
      setIsOpen_(false);
    }).catch(err => {
      setLoadingUpdate(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
    setTabla();
  }

  async function eliminar() {
    setLoadingDelete(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity');
    const _idTermination = deleteId;
    await apis.deleteSocial_benefits(_entity, _cliente, _idTermination, headers).then(res => {
      setLoadingDelete(false)
      setIsOpenEliminar(false)
      toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Registro eliminado con exito', life: 4000 });
    }).catch(err => {
      setLoadingDelete(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })

    setTabla();
  }

  const exportExcel = () => {
    excelExport(rowDataExport, 'Terceros')
    setLoading2(false)
  }

  addLocale('es', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Claro'
  });



  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModal} />
      </React.Fragment>
    )
  }

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button type="button" disabled={rowData.length === 0} icon="pi pi-file-excel" label="Exportar" loading={loading2} onClick={() => { setLoading2(true); exportExcel() }} className="p-button-success mr-2" data-pr-tooltip="XLS" />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" className="p-button-warning  p-button-sm text-xs mr-2" onClick={() => { inizilaizarData(rowData) }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }




  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'DOCUMENT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NIT': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'DV': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];



  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={completarRegistro} label='Guardar' loading={loadingCreate}></Button>
    </div>
  );

  const addHeader = (
    <div>
      <h3>Agregar Tercero</h3>
    </div>
  );

  const updateFooter = (
    <div>
      <Button onClick={hideModal_}>Cancelar</Button>
      <Button onClick={actualizar} label='Guardar' loading={loadingUpdate}></Button>
    </div>
  );

  const updateHeader = (
    <div>
      <h3>Actualizar Tercero</h3>
    </div>
  );

  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button onClick={eliminar} label='Si' loading={loadingDelete}></Button>
    </div>
  );

  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el Tercero</h3>
    </div>
  );

  return (

    <div>
      <Toast ref={toast} />

      <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
        <span className="text-900">Terceros</span>
        <Video header="Instructivo terceros" url={localStorage.getItem("ACCOUNTANTACCOUNT_PLAN_VIDEO")} />
      </div>
      <ConfBar />

      <div className="surface-100	 px-4 py-2 md:px-6 lg:px-8">

        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "32rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">Tipo de documento</LabelField>
          <Dropdown style={elementWidth} value={typeDocument.value} options={listaTypeDocument} onChange={setTypeDocument} placeholder={"Selecione tipo de documento"} />
          <LabelField htmlFor="label">Nit</LabelField>
          <InputText style={{ width: "27rem" }} value={companyNit} onChange={(e) => setCompanyNit(e.target.value)} placeholder="Ingrese nit" />
          <LabelField htmlFor="label">Dígito de verificación</LabelField>
          <div class="block">
            <InputText
              style={{ width: "3rem" }}
              type="text"
              maxLength={1}
              value={digitoVerificacion}
              onChange={(e) => setDigitoVerificacion(e.target.value)}
            />
          </div>
          <LabelField htmlFor="label">Nombre de la entidad</LabelField>
          <InputText style={{ width: "27rem" }} value={nameCompany} onChange={(e) => setNameCompany(e.target.value)} placeholder="Ingrese nombre de la entidad" />
        </Dialog>

        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} position="top" style={{ width: "32rem" }} draggable={false} resizable={false} modal onHide={hideModal_}>
          <LabelField htmlFor="label">Tipo de documento</LabelField>
          <Dropdown style={elementWidth} value={updateTypeDocument.value} options={listaTypeDocument} onChange={setUpdateTypeDocument} placeholder={updateTypeDocument.label} />
          <LabelField htmlFor="label">Nit</LabelField>
          <InputText style={{ width: "27rem" }} value={updateCompanyNit} onChange={(e) => setUpdateCompanyNit(e.target.value)} placeholder="Ingrese nit" />
          <LabelField htmlFor="label">Dígito de verificación</LabelField>
          <div class="block">
            <InputText
              style={{ width: "3rem" }}
              type="text"
              maxLength={1}
              value={updateDigitoVerificacion}
              onChange={(e) => setUpdateDigitoVerificacion(e.target.value)}
            />
          </div>
          <LabelField htmlFor="label">Nombre de la entidad</LabelField>
          <InputText style={{ width: "27rem" }} value={updateNameCompany} onChange={(e) => setUpdateNameCompany(e.target.value)} placeholder="Ingrese nombre de la entidad" />
        </Dialog>




        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate} />
            <DataTable className="text-xs" value={rowData} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              scrollHeight="flex" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="THIRD_ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['DOCUMENT_TYPE', 'NIT', 'DV', 'NAME']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="DOCUMENT_TYPE" header="Tipo de Documento" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por tipo de documento" sortable></Column>
              <Column field="NIT" header="Nit" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nit" sortable></Column>
              <Column field="DV" header="Digito" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Digito" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>

      </div>

    </div>
  );
}